import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

async function finalisasi(category: string, id: number) {
  const response = await http
    .putData(`/suket/${category}/${id}/finalisasi`, {})
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

export default {
  finalisasi
};
